// Central place for external store links, contact info, and the Show, Don't Tell collection.
// To activate an Amazon link later: set `amazon` to the product URL and `amazonComingSoon` to false.

export const TPT_STORE_URL = "https://www.teacherspayteachers.com/Store/Embracethemagicofwords";
export const TPT_SHOW_DONT_TELL_URL =
  "https://www.teacherspayteachers.com/store/embracethemagicofwords/category-show-dont-tell-writing-1645705";
export const AMAZON_STORE_URL = "https://www.amazon.com/Embrace-the-Magic-of-Words/e/B0H63LZKS7";
// Verified via amazon.com/dp/B0H5T4TXBZ — this ASIN is the "Embrace the Magic of Words Workbooks" SERIES page, not a single book.
export const AMAZON_SERIES_URL = "https://www.amazon.com/dp/B0H5T4TXBZ";

const amz = (img) => `https://m.media-amazon.com/images/I/${img}._SY500_.jpg`;

// Published paperbacks on Amazon. To activate a coming-soon title: set `asin` and `comingSoon: false`.
export const AMAZON_BOOKS = [
  { id: "vocab", title: "Vocabulary Workbook for Kids & Teachers", subtitle: "Spacious writing practice for meaning, synonyms, antonyms & sentence building", grades: "Grades 2–5", asin: "B0GZ5Y3GZZ", cover: amz("51ZCAHtNXnL") },
  { id: "building-sentences", title: "Building Sentences Workbook: Vocabulary and Parts of Speech Practice for Grades 2–5", subtitle: "22 vocabulary words · trace, build, and write sentences", grades: "Grades 2–5", asin: "B0H5HH3511", cover: amz("41HpbpYe8jL") },
  { id: "wh-1", title: "5 WH Questions Workbook for Kids — Level 1", subtitle: "Who, What, Where, When & Why activities for early readers", grades: "Ages 5–8 · Grades K–2", asin: "B0H66CMHYP", cover: amz("41ef8CSaDPL") },
  { id: "wh-2", title: "WH Questions Workbook — Level 2", subtitle: "Reading comprehension, critical thinking, vocabulary & question building", grades: "Grades 2–4", asin: "B0H66MWF1B", cover: amz("418BY7NDyzL") },
  { id: "fix-sentence", title: "Fix the Sentence Workbook for Kids", subtitle: "Grammar editing practice with 25 vocabulary words", grades: "Grades 2–5", asin: "B0H6CHQHR4", cover: amz("4151V+NX-GL") },
  { id: "show-it-feelings", title: "Show It! Feelings in Action: A Show, Don't Tell Writing Workbook for Describing Emotions", subtitle: "6 feelings · 34-page paperback · teacher's guide & answer key", grades: "2nd–3rd Grade", asin: "B0HLWTBPMH", cover: amz("61xi5MEug2L"), collection: "show-it" },
  { id: "show-it-places", title: "Show It! Places & Settings in Action: A Show, Don't Tell Writing Workbook for Descriptive Writing and Sensory Details", subtitle: "5 settings · 40-page paperback · supported practice & answer key", grades: "2nd–3rd Grade", asin: "B0HLWTHXGN", cover: amz("61FHgnuXS-L"), collection: "show-it" },
  { id: "show-it-traits", title: "Show It! Character Traits in Action: A Show, Don't Tell Writing Workbook", subtitle: "Show kind, brave, honest and more through actions, words, and choices", grades: "2nd–3rd Grade", asin: "B0HNXNTFVF", comingSoon: false, cover: amz("61KjdBgASEL"), collection: "show-it" },
];

export const amazonUrl = (book) => (book.asin ? `https://www.amazon.com/dp/${book.asin}` : null);
export const FREE_WORKSHEET_URL =
  "https://www.teacherspayteachers.com/Product/Vocabulary-Context-Clues-Tracing-Worksheets-Synonyms-Antonyms-SPED-ESL-ELL-OT-15596502";
export const CONTACT_EMAIL = "magic@ann-solutions.com";

const thumb = (slug, id, n) => `https://ecdn.teacherspayteachers.com/thumbitem/${slug}/original-${id}-${n}.jpg`;

export const SHOW_DONT_TELL = [
  {
    id: "17698229",
    title: "Show, Don't Tell: Feelings",
    subtitle: "Writing Workbook · Grades 2–3",
    price: "$5.95",
    cover: thumb("Show-Don-t-Tell-Feelings-Writing-Workbook-2nd-3rd-Grades-SPED-ESL-ELL-17698229-1789844045", "17698229", 1),
    inside: thumb("Show-Don-t-Tell-Feelings-Writing-Workbook-2nd-3rd-Grades-SPED-ESL-ELL-17698229-1789844045", "17698229", 3),
    tpt: "https://www.teacherspayteachers.com/Product/Show-Dont-Tell-Feelings-Writing-Workbook-2nd-3rd-Grades-SPED-ESLELL-17698229",
    amazon: "https://www.amazon.com/dp/B0HLWTBPMH",
    amazonComingSoon: false,
    blurb: "6 feelings — scared, happy, angry, sad, excited, nervous — shown through actions, dialogue, and physical detail.",
    inside_list: ["Directions + example sentences", "Multiple-choice practice", "Tracing model sentences", "Writing spaces"],
  },
  {
    id: "17810938",
    title: "Show, Don't Tell: Places & Settings",
    subtitle: "Descriptive Writing Worksheets · Grades 2–3",
    price: "$4.50",
    cover: thumb("Show-Don-t-Tell-Descriptive-Writing-Worksheets-2nd-3rd-Grade-Settings-17810938-1790887248", "17810938", 1),
    inside: thumb("Show-Don-t-Tell-Descriptive-Writing-Worksheets-2nd-3rd-Grade-Settings-17810938-1790887248", "17810938", 3),
    tpt: "https://www.teacherspayteachers.com/Product/Show-Dont-Tell-Descriptive-Writing-Worksheets-2nd3rd-Grade-Settings-17810938",
    amazon: "https://www.amazon.com/dp/B0HLWTHXGN",
    amazonComingSoon: false,
    blurb: "5 familiar settings — playground, library, kitchen, beach, rainy street — described with vivid sensory details.",
    inside_list: ["Sights, sounds & actions chart", "Choose the stronger description", "Trace, then complete", "Independent writing"],
  },
  {
    id: "17862427",
    title: "Show, Don't Tell: Character Traits",
    subtitle: "Writing Worksheets · Grades 2–3",
    price: "$6.95",
    cover: thumb("Show-Don-t-Tell-Character-Traits-Writing-Worksheets-2nd-3rd-Grade-ELA-17862427-1791303018", "17862427", 1),
    inside: thumb("Show-Don-t-Tell-Character-Traits-Writing-Worksheets-2nd-3rd-Grade-ELA-17862427-1791303018", "17862427", 3),
    tpt: "https://www.teacherspayteachers.com/Product/Show-Dont-Tell-Character-Traits-Writing-Worksheets-2nd3rd-Grade-ELA-17862427",
    amazon: "https://www.amazon.com/dp/B0HNXNTFVF",
    amazonComingSoon: false,
    blurb: "Show kind, brave, honest and more through a character's actions, words, choices, and reactions.",
    inside_list: ["Same predictable 3-page sequence", "Identify the clues", "Trace model sentences", "Create your own"],
  },
  {
    id: "17811870",
    title: "Complete Show, Don't Tell Writing Activities Bundle",
    subtitle: "All 3 workbooks · Grades 2–3 · SPED · ESL/ELL",
    price: "$15.65",
    originalPrice: "$17.40",
    cover: thumb("Show-Don-t-Tell-Writing-Activities-Bundle-2nd-3rd-Grade-SPED-ESL-ELL-17811870-1791304602", "17811870", 1),
    inside: thumb("Show-Don-t-Tell-Writing-Activities-Bundle-2nd-3rd-Grade-SPED-ESL-ELL-17811870-1791304602", "17811870", 3),
    tpt: "https://www.teacherspayteachers.com/Product/Show-Dont-Tell-Writing-Activities-Bundle-2nd3rd-Grade-SPED-ESLELL-17811870",
    amazon: null,
    amazonComingSoon: false,
    bundle: true,
    blurb: "Feelings + Places & Settings + Character Traits in one structured bundle — identify, trace, complete, rewrite, create.",
    inside_list: ["3 complete workbooks", "Teacher's guides & answer keys", "Supported-practice pages", "No prep — print and go"],
  },
];
